<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">
								View Training Record
							</div>
							<!--页头-->
							<div class="page_main">
								<el-form ref="trainForm" :model="info" label-position="top" class="request-form">
									<el-form-item label="Training Item" class="full-width-item">
										<div class="gray-input">
											{{ info.item_name || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="Training Item Type" class="full-width-item">
										<div class="gray-input">
											{{ info.leixing_name || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="User" class="full-width-item">
										<div class="gray-input">
											{{ info.username || "/" }}
										</div>
									</el-form-item>
									
									<!-- <el-form-item label="Company">
										<div class="gray-input">
											{{ info.company_name || "/" }}
										</div>
									</el-form-item> -->
									
									<el-form-item label="Department">
										<div class="gray-input">
											{{ info.departments_name || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="Training Purpose">
										<div class="gray-input">
											{{ info.purpose || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="Training Status">
										<div class="gray-input">
											{{ info.status || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="Training Completion Date">
										<div class="gray-input">
											{{ info.completed_time || "/" }}
										</div>
									</el-form-item>
									
									<el-form-item label="Monitor">
										<div class="gray-input">
											{{ info.monitor_username || "/" }}
										</div>
									</el-form-item>
									<div class="train_box">
										<div class="type-title">
											Training
										</div>
									
										<el-form-item label="Training Completed" class="full-width-item">
											<div class="gray-input">
												{{ info.training_signoff_completed || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Due Date" class="full-width-item">
											<div class="gray-input">
												{{ info.end_time || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Assigned User" class="full-width-item">
											<div class="gray-input">
												{{ info.is_assigned || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Type">
											<div class="gray-input">
												{{ info.train_leixing_name || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Requirement Met?">
											<div class="gray-input">
												{{ info.is_meet || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Comments">
											<div class="gray-input">
												{{ info.training_comments || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Sign-off User">
											<div class="gray-input">
												{{ info.training_signoff_username || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Sign-off Authorization">
											<div class="gray-input">
												{{ info.training_signoff_authorization || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Training Sign-off Date">
											<div class="gray-input">
												{{ info.training_completed_date || "/" }}
											</div>
										</el-form-item>
									</div>
									<div v-if="trainHistoryData.length > 0" class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Training Due Date Change History
											</div>
										</div>
									
										<el-table
											:data="trainHistoryData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											class="history-table"
										>
											<el-table-column label="Previous Due Date" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.old_time || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column label="New Due Date" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.new_time || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column label="Justification" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.justification || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column
												prop="changeusername"
												label="Changed By"
												sortable
												min-width="160"
											/>
									
											<el-table-column label="Change Date" min-width="160">
												<template slot-scope="scope">
													{{ initTime(scope.row.change_time) }}
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div v-if="evidenceData.length > 0" class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Training Evidence Files
											</div>
										</div>
									
										<el-table
											:data="evidenceData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											class="history-table"
											empty-text="No training evidence files found."
										>
											<el-table-column prop="flie_name" label="File Name" sortable min-width="220">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">
														{{ scope.row.name }}
													</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="certification_box">
										<div class="type-title">
											Certification
										</div>
										<el-form-item label="Certification Completed">
											<div class="gray-input">
												{{ info.certification_completed || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Is Certification Required?">
											<div class="gray-input">
												{{ info.is_certification || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Required Certification Due Date">
											<div class="gray-input">
												{{ info.certification_end_time || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Certification Method">
											<div class="gray-input">
												{{ info.certification_method || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Certification Sign-off Timestamp">
											<div class="gray-input">
												{{ info.certification_completed_date || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Certification Sign-off User">
											<div class="gray-input">
												{{ info.certification_signoff_uesrname || "/" }}
											</div>
										</el-form-item>
										<!-- <el-form-item label="Certification Signature Timestamp">
											<div class="gray-input">
												{{ info.cer_sign || "/" }}
											</div>
										</el-form-item> -->
									</div>
									<div v-if="cerCompleteData.length > 0" class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Certification Evidence Files
											</div>
										</div>
										<el-table :data="cerCompleteData" border stripe
											header-cell-class-name="table-header-cell" class="history-table"
											empty-text="No certification evidence has been added.">
											<el-table-column prop="flie_name" label="File Name" sortable min-width="220">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									
									<div v-if="cerChangeData.length > 0" class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Certification Due Date Change History
											</div>
										</div>
										<el-table :data="cerChangeData" border stripe
											header-cell-class-name="table-header-cell" class="history-table">
									
											<el-table-column label="Previous Date" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.old_time || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column label="New Date" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.new_time || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column label="Justification" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.justification || "/" }}
												</template>
											</el-table-column>
									
											<el-table-column prop="changeusername" label="Changed By" sortable
												min-width="160" />
									
											<el-table-column prop="" label="Change Date" min-width="160">
												<template slot-scope="scope">
													{{ initTime(scope.row.change_time) }}
												</template>
											</el-table-column>
									
										</el-table>
									</div>
									
									<div v-if="taskTableData.length > 0" class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Task History
											</div>
										</div>
									
										<el-table :data="taskTableData" border stripe
											header-cell-class-name="table-header-cell" class="history-table">
									
											<el-table-column prop="" label="Task Name" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.flow_type == 'train' ? 'Complete Training' : 'Training Effectiveness Evaluation' }}
												</template>
											</el-table-column>
									
											<!-- <el-table-column prop="company_name" label="Company" sortable
												min-width="220" /> -->
									
											<el-table-column prop="departments_name" label="Department" sortable
												min-width="220" />
									
											<el-table-column prop="" label="Task Status / Result" sortable min-width="160">
												<template slot-scope="scope">
													{{ scope.row.flow_type == 1 ? 'Incomplete' : 'Completed' }}
												</template>
											</el-table-column>
									
											<el-table-column prop="" label="Comments" sortable min-width="160">
												<template slot-scope="scope">
													{{ scope.row.remark || '/' }}
												</template>
											</el-table-column>
									
											<el-table-column prop="" label="Task Owner" sortable min-width="200">
												<template slot-scope="scope">
													{{ scope.row.apply_username || '/' }}
												</template>
											</el-table-column>
									
											<el-table-column prop="deadline" label="Task Due Date" sortable min-width="150">
												<template slot-scope="scope">
													{{ scope.row.end_time || '/' }}
												</template>
											</el-table-column>
									
											<el-table-column prop="finishDate" label="Completion Date" sortable min-width="100">
												<template slot-scope="scope">
													{{ scope.row.app_time || '/' }}
												</template>
											</el-table-column>
									
										</el-table>
									</div>
									
									<div class="footer-btn">
										<el-button type="primary" @click="handleClose">
											Close
										</el-button>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		trainDetail
	} from "@/api/trainManage/trainSearch/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import moment from "moment";
	moment.locale("zh-cn");
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				trainHistoryData: [], //培训要求截止日期变更历史记录
				cerCompleteData: [], //认证证据文件
				evidenceData: [], //培训证据文件
				info: {},
				cerChangeData: [], //认证要求截止日期变更历史记录
				taskTableData: [], //任务历史记录
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			//请求详情
			trainDetail({
				id: that.$route.query.id
			}).then(res => {
				if (res.code == 200) {
					// console.log(res.data);
					that.info.item_name = res.data.item_name;
					that.info.leixing_name = res.data.leixing_name;
					that.info.username = res.data.username;
					// that.info.company_name = res.data.company_name;
					that.info.departments_name = res.data.departments_name;
					that.info.purpose = res.data.purpose == 1 ? 'Initial Training' : 'Retraining';
					that.info.status = res.data.status == 1 ?
						'Training Incomplete' :
						res.data.status == 2 ?
						'Certification Pending' :
						res.data.status == 3 ?
						'Completed' :
						'/';
					that.info.completed_time = res.data.completed_time;
					that.info.monitor_username = res.data.monitor_username;
					//
					that.info.training_signoff_completed = res.data.training_signoff_completed == 1 ? 'Incomplete' :
					'Completed';
					that.info.end_time = res.data.end_time;
					that.info.is_assigned = res.data.is_assigned == 1 ? 'Yes' : 'No';
					that.info.train_leixing_name = res.data.train_leixing_name;
					that.info.is_meet = res.data.is_meet == 1 ? 'Yes' : 'No';
					that.info.training_comments = res.data.training_comments;
					that.info.training_signoff_username = res.data.training_signoff_username;
					that.info.training_signoff_authorization = res.data.training_signoff_authorization == 1 ?
						'Assigned to User' :
						res.data.training_signoff_authorization == 2 ?
						'Department Manager' :
						'/';
					that.info.training_completed_date = res.data.training_completed_date;
					//
					that.info.certification_completed = res.data.certification_completed == 1 ? 'Incomplete' : 'Completed';
					that.info.is_certification = res.data.is_certification == 1 ? 'Yes' : 'No';
					that.info.certification_end_time = res.data.certification_end_time;
					that.info.certification_method = res.data.certification_method;
					that.info.certification_completed_date = res.data.certification_completed_date;
					that.info.certification_signoff_uesrname = res.data.certification_signoff_uesrname;
					// 培训要求截止日期变更历史记录
					that.trainHistoryData = res.data.changetimelist ? res.data.changetimelist : [];
					// 培训证据文件
					that.evidenceData = res.data.filelist ? res.data.filelist : [];
					// 认证证据文件
					that.cerCompleteData = res.data.filelist2 ? res.data.filelist2 : [];
					// 认证要求截止日期变更历史记录
					that.cerChangeData = res.data.cerChangeData ? res.data.cerChangeData : [];
					// 任务历史记录
					that.taskTableData = res.data.applylist ? res.data.applylist : [];
					// console.log(that.taskTableData);
				}
				that.isLoading = false;
			});
		},
		watch: {
			//
		},
		methods: {
			//时间戳转换
			initTime(value) {
				if (value) {
					return moment(value * 1000).format('YYYY-MM-DD');
				}
			},
			handleClose() {
				let that = this;
				window.close();
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label 样式 */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	::v-deep .el-input__inner {
		height: 40px;
		line-height: 40px;
		border-radius: 8px;
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
	}

	/* 输入框统一风格 */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.table-card {
		margin-top: 16px;
		border: 1px solid #d8dde3;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
	}

	.table-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 14px 14px 10px;
		background: #f5f6f7;
		border-bottom: 1px solid #d8dde3;
	}

	.type-title {
		font-size: 23px;
		font-weight: 700;
		color: #2f343b;
		margin: 20px 0;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.table-tools {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.search-input {
		width: 230px;
	}

	.search-input ::v-deep .el-input__inner {
		border-radius: 8px;
		border: 1px solid #cfd5db;
		height: 40px;
		line-height: 40px;
	}

	.collapse-btn {
		width: 40px;
		height: 40px;
		padding: 0;
		border-radius: 8px;
	}

	.document-table {
		width: 100%;
	}

	.document-table ::v-deep .custom-table-header {
		background: #f4f6f8;
		color: #2f343b;
		font-weight: 700;
		font-size: 14px;
		border-bottom: 2px solid #3c4043;
	}

	.document-table ::v-deep .custom-table-cell {
		color: #2f343b;
		font-size: 14px;
	}

	.document-table ::v-deep .el-table__cell {
		padding: 12px 8px;
	}

	.document-table ::v-deep .cell {
		word-break: break-word;
		line-height: 1.5;
	}

	.divider {
		height: 1px;
		background: #dcdfe6;
		margin-top: 50px;
	}

	.footer-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 30px;
	}
</style>